import { Route, Routes } from 'react-router-dom';
import CodeEditorPage from './CodeEditorPage';
import DashboardPage from './DashboardPage';
import LoginPage from './LoginPage';
import ProjectsPage from './ProjectsPage';
import ExamplesPage from './ExamplesPage';
import ShareCodePage from './ShareCodePage';
import RapidRobotsPage from './RapidRobotsPage';
import BpsPrivacyPolicyPage from './BpsPrivacyPolicyPage';
import { PathBuilderRoute } from './PathBuilderRoute';

const BpsRoutes = () => {
  return (
    <Routes>
      <Route path="/" index element={<ProjectsPage />} />
      <Route path="/bps-privacy-policy" element={<BpsPrivacyPolicyPage />} />
      <Route path="/examples" element={<ExamplesPage />} />
      <Route path="/rapid-robots" element={<RapidRobotsPage />} />
      <Route path="/share/:shareCode" element={<ShareCodePage />} />
      <Route path="/editor/:id" element={<CodeEditorPage />} />
      <Route path="/pathbuilder/:id" element={<PathBuilderRoute />} />
      <Route path="/dashboard/:id" element={<DashboardPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/login" index element={<LoginPage />} />
    </Routes>
  );
};

export default BpsRoutes;
